
export function capitalizeEveryWord(str, exclusion = '') {
    return str.split(' ').map(word => {
        word = (word == exclusion ? word.toUpperCase() : word.toLowerCase())
        return (word !== exclusion ? word[0].toUpperCase() + word.substring(1) : word)
    }
    ).join(' ')
}

// export function omitZipCode(str) {
//     str = str.substring(str.)
// }
